/**
 * Maximum number of symbols a single market-data subscription may carry.
 *
 * Deliberately its own module: `snapshotStream.ts` is factory-mocked by several
 * test suites, and factory mocks throw on exports the factory does not declare.
 */
export const MAX_SYMBOLS = 100;
